<template>
    <b-container class="offers-wrapper">
        <div class="offers">
            <b-row class="justify-content-center">
                <b-col class="mb-4">
                    <h1 v-t="'offers.title'"></h1>
                </b-col>
            </b-row>
            
            <b-row class="justify-content-center">
                <b-col class="mb-4">
                    <h2 v-t="'offers.description'"></h2>
                </b-col>
            </b-row>
            
            
    
            <b-row class="offers__steps" align-h="between">
                <b-col class="offers__item mb-4" lg="3" md="4" sm="12"  v-for="(offer, i) in offers" :key="offer.title">
                    <div class="offers__step mb-4">
                        {{ i+1 }}
                    </div>
                    
                    <h3 v-html="$t(`offers.steps.${offer.key}.title`)"></h3>
                    <h4 v-html="$t(`offers.steps.${offer.key}.description`)"></h4>
                </b-col>
            </b-row>

            <p class="mt-2">
                <small v-t="'offers.schedule'"></small>
                <br />
                <small v-html="$t('offers.payment')"></small>
            </p>
        </div>
    </b-container>
</template>

<script>
    export default {
        data() {
            return {
                offers: [
                    {
                        key: "one"
                    },
                    {
                        key: "two"
                    },
                    {
                        key: "three"
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

    .offers-wrapper {
        background: $color-dirty-white;
        margin-top: -$main-side-margins;

        border-radius: 10px;

        display: flex;
        justify-content: center;
    }

    .offers {
        padding: 3.75rem 0 0;
        max-width: 900px;

        &__item {
            box-shadow: 0 0 5px rgba(17, 25, 28, 0.15);
            border-radius: 9px;
            padding: 1.875rem;
            background: $color-white;
        }

        &__step {
            font-size: 1.625rem;
            font-weight: 700;
            color: $primary-color;

            height: 3.125rem;
            width: 3.125rem;

            border-radius: 50%;
            border: solid 2px $primary-color;
            margin-left: auto;
            margin-right: auto;

            display: flex;
            justify-content: center;
            align-items: center;
        }


    }

</style>